import React from "react";
import Marty from "marty";
import { RouteHandler, State } from "react-router";
import Header from "./components/Header";
import Footer from "./components/Footer";
import config from "../config/config.js";
import ConfirmModal from "../utils/components/ConfirmModal";
import BuyButton from "./components/BuyButton";
import MailingList from "./components/MailingList";
import { Modal } from "react-bootstrap";

let App = React.createClass({
    mixins: [State],
    componentWillMount() {
        if (!Marty.isServer) { window.scrollTo(0, 0); }
    },
    closeMenu(){
        this.app.navActions.toggleMenu(true);
    },
    closeModal() {
        this.closeMenu();
        this.app.navStore.hideMailingListModal();
        this.setState({ emailSubmitted: false });
    },
    emailSubmitted() {
        this.setState({ emailSubmitted: true });
    },
    openModal() {
        this.app.navStore.showMailingListModal();
    },
    render() {
        return (
          <div className="eo-app">
              {this.props.hidden.header ? null : <Header collapseDistance={config.headerCollapseDistance} /> }
              <div className="eo-view-wrap container">
                  <RouteHandler />
              </div>
              {this.props.hidden.footer ? null : <Footer /> }
              {this.props.hidden.buyButton ? null : <BuyButton className="btn-fixed" />}
              <Modal className="mailing-list-modal" dialogClassName="eo-modal" show={this.props.showMailingListModal}
                     onHide={this.closeModal}>
                  <Modal.Header closeButton />
                  <Modal.Body>
                      { this.state.emailSubmitted ? <h3>Thanks! We'll keep you posted</h3> : (
                        <div>
                            <h3><strong>eero will be available to order<br />later this month.</strong></h3>
                            <p>Leave your email address and you'll be the first to know.</p>
                            <MailingList onSuccess={this.emailSubmitted} />
                        </div>
                      )}
                  </Modal.Body>
              </Modal>
              <ConfirmModal
                show={!!this.props.confirmData}
                confirm={this.props.confirmData ? this.props.confirmData.confirm : null}
                message={this.props.confirmData ? this.props.confirmData.message : null} />
          </div>
        );
    },
    getInitialState() {
        return {
            hideHeader: false,
            hideFooter: false,
            hideBuyButton: false,
            emailSubmitted: false
        };
    }
});

export default Marty.createContainer(App, {
    listenTo: ["gatewayStore", "navStore"],
    fetch: {
        stripeData() {
            return this.app.gatewayStore.fetch();
        },
        showMailingListModal() {
            return this.app.navStore.mailingListModalVisible();
        },
        addressData() {
            return this.app.userStore.fetchAddressData();
        },
        hidden() {
            return this.app.navStore.hidden();
        },
        confirmData() {
            return this.app.navStore.fetchModalData("confirm");
        }
    }
});




/** WEBPACK FOOTER **
 ** ./app/views/Handler.js
 **/